 
import React, { useEffect, useRef, useState } from "react";

import video1 from "./motor.mp4";
import video2 from "./blondie.mp4";
import video3 from "./drive.mp4";

const PercheSceglierci = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const cards = [
    {
      video: video1,
      title: "Preparazione seria",
      text: "Teoria, pratica e guida affrontate con attenzione.",
    },
    {
      video: video2,
      title: "Ti seguiamo davvero",
      text: "Un punto di riferimento durante tutto il percorso.",
    },
    {
      video: video3,
      title: "Tutto più semplice",
      text: "Informazioni chiare e assistenza senza complicazioni.",
    },
  ];

  // IntersectionObserver
  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);

          // Una volta partita l'animazione,
          // smettiamo di osservare per non ripeterla.
          observer.unobserve(section);
        }
      },
      {
        threshold: 0.15,
      }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="chi-siamo"
      className="relative overflow-hidden bg-white"
    >
      <div className="relative min-h-screen">
        <div className="relative z-10">
          <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-24 md:py-32">

            {/* HEADER */}
            <div
              className={`
                max-w-3xl mx-auto mb-12 md:mb-16 text-center
                transition-all duration-700 ease-out
                ${
                  isVisible
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-8"
                }
              `}
            >
              <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#3FA66B] mb-4">
                Perché sceglierci
              </p>

              <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-black">
                Un percorso semplice.
                <br />
                Una patente in più.
              </h2>

              <p className="mt-5 max-w-xl mx-auto text-base md:text-lg leading-relaxed text-black/65">
                Ti accompagniamo con chiarezza e attenzione in ogni fase del
                percorso.
              </p>
            </div>

            {/* CARDS */}
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
              {cards.map((card, index) => (
                <div
                  key={index}
                  style={{
                    transitionDelay: isVisible
                      ? `${index * 140}ms`
                      : "0ms",
                  }}
                  className={`
                    group relative overflow-hidden
                    h-[430px] md:h-[500px]
                    rounded-3xl
                    border border-black/10

                    transition-all
                    duration-700
                    ease-[cubic-bezier(0.22,1,0.36,1)]

                    ${
                      isVisible
                        ? "opacity-100 translate-y-0 scale-100"
                        : "opacity-0 translate-y-14 scale-[0.96]"
                    }

                    hover:-translate-y-2
                    hover:shadow-[0_30px_80px_rgba(0,0,0,0.25)]
                  `}
                >
                  {/* VIDEO */}
                  <video
                    src={card.video}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    className="
                      absolute inset-0
                      w-full h-full
                      object-cover

                      transition-transform
                      duration-[1200ms]
                      ease-out

                      group-hover:scale-[1.07]
                    "
                  />

                  {/* GREY OVERLAY 70% */}
                  <div
                    className="
                      absolute inset-0
                      bg-gray-700/70
                      transition-colors
                      duration-500

                      group-hover:bg-gray-700/55
                    "
                  />

                  {/* DARK GRADIENT */}
                  <div
                    className="
                      absolute inset-0
                      bg-gradient-to-t
                      from-black/70
                      via-black/10
                      to-transparent
                    "
                  />

                  {/* CONTENT */}
                  <div
                    className="
                      absolute inset-0 z-10
                      flex flex-col justify-end
                      p-7 md:p-8

                      transition-transform
                      duration-500
                      ease-out

                      group-hover:-translate-y-2
                    "
                  >
                    {/* GREEN LINE */}
                    <div
                      className="
                        w-10 h-1
                        bg-[#3FA66B]
                        rounded-full
                        mb-5

                        transition-all
                        duration-500
                        ease-out

                        group-hover:w-16
                      "
                    />

                    {/* TITLE */}
                    <h3
                      className="
                        text-3xl
                        md:text-[30px]
                        font-semibold
                        tracking-tight
                        leading-tight
                        text-white
                      "
                    >
                      {card.title}
                    </h3>

                    {/* TEXT */}
                    <p
                      className="
                        mt-4
                        max-w-sm
                        text-[15px]
                        md:text-base
                        leading-relaxed
                        text-white/75

                        transition-opacity
                        duration-500
                        group-hover:text-white/90
                      "
                    >
                      {card.text}
                    </p>
                  </div>

                  {/* BORDER HOVER */}
                  <div
                    className="
                      absolute inset-0
                      rounded-3xl
                      border border-transparent

                      transition-all
                      duration-500

                      group-hover:border-[#3FA66B]/40
                      pointer-events-none
                    "
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PercheSceglierci;
 
